import React, { useState } from "react";
import axios from "axios";
import "./signup.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [isLoading, setIsLoading] = useState(false); // ✅ Added loading state
  const navigate = useNavigate();

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // ✅ Set loading to true when submitting

    try {
      const response = await axios.post(
        "https://backend-n2zq.onrender.com/api/signup",
        userData
      );

      toast.success(response.data.message);
      setTimeout(() => {
        navigate("/verify", { state: { email: userData.email } });
      }, 2000);
    } catch (error) {
      toast.error(error.response?.data?.message || "Error signing up");
    } finally {
      setIsLoading(false); // ✅ Reset loading state after response
    }
  };

  return (
    <div className="container">
      <div>
        <form onSubmit={handleSubmit}>
          <h1>SIGN UP</h1>
          <div className="input-container">
            <input
              id="email"
              type="text"
              name="email"
              value={userData.email}
              onChange={handleChange}
              required
            />
            <label>Email</label>
          </div>

          <div className="input-container">
            <input
              id="name"
              type="text"
              name="name"
              value={userData.name}
              onChange={handleChange}
              required
            />
            <label>Username</label>
          </div>

          <div className="input-container">
            <input
              id="password"
              type="password"
              name="password"
              value={userData.password}
              onChange={handleChange}
              required
            />
            <label>Password</label>
          </div>

          {/* ✅ Use isLoading state for button */}
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Loading..." : "SIGNUP"}
          </button>
        </form>
      </div>

      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default SignUp;

  